import React from 'react';
import { Popup as OriginalPopup } from 'antd-mobile';
const Popup = (props) => {
    const { content, ...innerProps } = props;
    return (React.createElement(OriginalPopup, Object.assign({}, innerProps),
        React.createElement("div", null, content)));
};
export default Popup;
